import React from "react";
import { Row, Col } from "react-bootstrap";
import { Margin } from "shared/utils";
import Money from "shared/components/Money";

function Pricing(props) {
  const { product } = props;

  const margin = new Margin(product.vat, product.purchasingPrice, product.rrp);

  return (
    <Row className="pricing">
      <Col md={3} xs={3}>
        <strong>
          <Money value={product.rrp} />
        </strong>
        <small>UVP</small>
      </Col>
      <Col md={3} xs={3}>
        <strong>
          <Money value={product.purchasingPrice} />
        </strong>
        <br />
        <small>EK</small>
      </Col>
      <Col md={3} xs={3}>
        <strong className={`margin ${margin.highlightColor()}`}>
          {margin.marginFormatted()}
        </strong>
        <br />
        <small>Spanne</small>
      </Col>
      <Col md={3} xs={3}>
        <strong>
          <Money value={margin.absMargin()} />
        </strong>
        <br />
        <small>St.-Nutzen</small>
      </Col>
    </Row>
  );
}

export default Pricing;
